import { Subject, PriceSortQueryValue, NumericFilter, Refinements } from '@packages/common';

// NOTE: these should not be exported for this package and are exposed through useRefinementsEvents
export const priceSort$ = new Subject<PriceSortQueryValue>(PriceSortQueryValue.NONE);
export const clearAll$ = new Subject<void>(undefined);
export const facetFilter$ = new Subject<{ facetSeoName: string; valueSeoName: string; isActive: boolean }>({} as any);
export const refinementsChangedDeep$ = new Subject<Refinements | undefined>(undefined);
export const numericFilter$ = new Subject<{ value?: NumericFilter; seoName: string }>({} as any);
export const toggleFilter$ = new Subject<{ isActive: boolean; seoName: string; value: boolean }>({} as any);
